import { applyMiddleware, compose, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';

import employerReducer from './app-reducer';
import { InitialState as DisplaySettingsInitialState } from './display-settings-reducer';

import { isProd } from '../config/config';
import { LocalStorageController } from '../util/local-storage-controller';
import { DISPLAY_SETTINGS_KEY } from '../util/local-storage-keys';

export class StoreManager {
  static store: any;

  static init = () => {
    const composeEnhancers =
      (isProd ? null : (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
    const displaySettingString = LocalStorageController.getItem(DISPLAY_SETTINGS_KEY);
    const displaySettings = displaySettingString ? JSON.parse(displaySettingString) : undefined;
    StoreManager.store = createStore(
      employerReducer,
      { displaySettings: { ...DisplaySettingsInitialState, ...displaySettings } } as any,
      composeEnhancers(applyMiddleware(thunkMiddleware)),
    );
    return StoreManager.store;
  };

  static getStore = () => {
    if (!StoreManager.store) {
      return StoreManager.init();
    }
    return StoreManager.store;
  };
}
